import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';
import { BehaviorSubject } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class SupplierService {
  suppliersOnChange = new BehaviorSubject([]);
  supplierVehiclesOnChange = new BehaviorSubject([]);
  selectedVehicle = new BehaviorSubject({});
  selectedVehicleIndex = new BehaviorSubject(0);

  constructor(
    private http: HttpClient,
    private message: NzMessageService,
  ) {}

  createSupplier(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/supplier/create`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getSuppliersPaged(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/supplier/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getAllSuppliers(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/supplier/get-all`).subscribe({
        next: (response: any) => {
          this.suppliersOnChange.next(response);
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error.message);
        },
      });
    });
  }

  getSupplierBookings(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/supplier/get-bookings`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getSuppliersById(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/supplier/get/${payload}`, payload)
        .subscribe({
          next: (response: any) => {
            this.supplierVehiclesOnChange.next(response.vehicles);
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getSupplierByEmail(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/supplier/get-by-email`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  updateSuppliers(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.put(`${SETTINGS.BASE_API}/supplier/update`, payload).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error.message);
        },
      });
    });
  }

  deleteSupplier(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${SETTINGS.BASE_API}/supplier/soft-delete/${id}`)
        .subscribe({
          next: (response: any) => {
            this.message.create('success', `Supplier has been deleted!`);
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }
}
